import React, { useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import { Message, Switch, Button, Spin } from "../../../BP2Components";
import { filterColumns } from "./KanbanSettings";
import { Icon_Plus } from "../../../BP2Components/Icons/icons";
import "./kanbanSettings.less";
import "../AdvertisementList/advertisementListSettings.less";

const { Option } = Select;

const KanbanItemSettings = ({ value, columns, rows, loading, areInstancesIncluded }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [itemContent, setItemContent] = useState(value?.itemContent ?? []);

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams({ ...value, itemContent }));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const updateItemContent = (option, rowIndex, columnIndex, value) => {
      let newItemContent = [...itemContent];
      switch (option) {
         case "addColumn":
            newItemContent[rowIndex].columns = [
               ...newItemContent[rowIndex].columns,
               {
                  columnTechName: filterColumns(columns, rows)?.[0]?.techName,
                  showColumnName: false
               }
            ];
            break;
         case "deleteColumn":
            newItemContent[rowIndex].columns = [
               ...newItemContent[rowIndex].columns.filter((_, index) => index !== columnIndex)
            ];
            break;
         case "addRow":
            newItemContent = [...newItemContent, { columns: [] }];
            break;
         case "deleteRow":
            newItemContent = [...newItemContent.filter((_, index) => index !== rowIndex)];
            break;
         case "changeOption":
            newItemContent[rowIndex].columns[columnIndex].columnTechName = value;
            break;
         case "changeShowColumnName":
            newItemContent[rowIndex].columns[columnIndex].showColumnName = value;
            break;
         case "changeSumColumn":
            newItemContent[rowIndex].columns[columnIndex].sumColumn = value;
      }
      setItemContent(newItemContent);
   };

   return (
      <>
         <form
            onSubmit={handleSubmit}
            className="kanban-settings-container"
         >
            <div className="padding-left-15">
               <div key="globalSettings" >
                  <IntlMessages id="settings.itemContent" />:
                  <div className="item-content-container">
                     <div className="item-content-rows-list">
                        {itemContent &&
                           itemContent.map((row, rowIndex) => {
                              return (
                                 <div className="item-content-row-container">
                                    <div className="item-content-row-name">
                                       <IntlMessages id="settings.row" /> {rowIndex + 1}
                                    </div>
                                    <div className="item-content-columns-list">
                                       {row.columns.map((column, columnIndex) => {
                                          return (
                                             <div className="item-content-column-container">
                                                <div className="item-content-column-name">
                                                   <IntlMessages id="settings.column" />
                                                   {columnIndex + 1}
                                                </div>
                                                <Select
                                                   value={column.columnTechName}
                                                   onChange={(e) =>
                                                      updateItemContent(
                                                         "changeOption",
                                                         rowIndex,
                                                         columnIndex,
                                                         e
                                                      )
                                                   }
                                                >
                                                   {areInstancesIncluded && (
                                                      <Option value={"__showProcesses"} key={0}>
                                                         <IntlMessages id="kanban.processes" />
                                                      </Option>
                                                   )}
                                                   {filterColumns(columns, rows).map(
                                                      ({ techName, title }, i) => (
                                                         <Option value={techName} key={i}>
                                                            {title}
                                                         </Option>
                                                      )
                                                   )}
                                                </Select>
                                                <Button
                                                   buttonType="danger"
                                                   onClick={() =>
                                                      updateItemContent(
                                                         "deleteColumn",
                                                         rowIndex,
                                                         columnIndex
                                                      )
                                                   }
                                                   style={{ marginLeft: "40px" }}
                                                >
                                                   <IntlMessages id="settings.deleteColumn" />
                                                </Button>
                                                <div className="item-content-switch-container">
                                                   <div style={{ marginRight: "10px" }}>
                                                      <IntlMessages id="settings.showColumnName" />
                                                   </div>
                                                   <Switch
                                                      onChange={(e) =>
                                                         updateItemContent(
                                                            "changeShowColumnName",
                                                            rowIndex,
                                                            columnIndex,
                                                            e
                                                         )
                                                      }
                                                      checked={column.showColumnName}
                                                   />
                                                </div>
                                                <div className="item-content-switch-container">
                                                   <div style={{ marginRight: "10px" }}>
                                                      <IntlMessages id="settings.sumColumn" />
                                                   </div>
                                                   <Switch
                                                      onChange={(e) =>
                                                         updateItemContent(
                                                            "changeSumColumn",
                                                            rowIndex,
                                                            columnIndex,
                                                            e
                                                         )
                                                      }
                                                      checked={column.sumColumn}
                                                   />
                                                </div>
                                             </div>
                                          );
                                       })}
                                    </div>
                                    <Button
                                       buttonType="danger"
                                       onClick={() => updateItemContent("deleteRow", rowIndex)}
                                    >
                                       <IntlMessages id="settings.deleteRow" />
                                    </Button>
                                    <Button
                                       onClick={() => updateItemContent("addColumn", rowIndex)}
                                    >
                                       <Icon_Plus /> <IntlMessages id="settings.addColumn" />
                                    </Button>
                                 </div>
                              );
                           })}
                     </div>
                     <Button
                        buttonType="primary"
                        disabled={loading}
                        onClick={() => updateItemContent("addRow")}
                     >
                        <Icon_Plus /> <IntlMessages id="settings.addRow" />
                     </Button>
                  </div>
                  {loading ? (
                     <div className="kanban-settings-loader">
                        <Spin />
                     </div>
                  ) : null}
                     <Button
                        key="btn"
                        buttonType="primary"
                        htmlType="submit"
                        className="kanban-settings-save"
                     >
                        <IntlMessages id="global.preview" />
                     </Button>
               </div>
            </div>
         </form>
      </>
   );
};

export default KanbanItemSettings;
